import request from '@/utils/request'
import {getCommunityId} from '@/api/community/communityApi'

//轮播图
export function getTo(params) {
    return new Promise((resolve, reject) => {
        request({
            url: '/xiaoxiang.api.wxxcx.getTo',
            method: 'get',
            params
        }).then(response => {
            const res = response.data
            if (res.code == 0) {
                resolve(res)
            } else {
                reject(new Error(res.msg || '查询失败'))
            }
        }).catch(error => {
            reject(error)
        })
    })
}

//房型列表
export function fangxingList(params) {
    return new Promise((resolve, reject) => {
        params.communityId = getCommunityId()
        request({
            url: '/xiaoxiang.fang.fangxing.list',
            method: 'get',
            params
        }).then(response => {
            const res = response.data
            if (res.code == 0) {
                resolve(res)
            } else {
                reject(new Error(res.msg || '查询失败'))
            }
        }).catch(error => {
            reject(error)
        })
    })
}
export function listAllFangxing() {
    return new Promise((resolve, reject) => {
        request({
            url: '/xiaoxiang.fang.fangxing.listAll',
            method: 'post',
            data:{'id':'1'},
        }).then(response => {
            const res = response.data
            if (res.code == 0) {
                resolve(res)
            } else {
                reject(new Error(res.msg || '查询失败'))
            }
        }).catch(error => {
            reject(error)
        })
    })
}

// 房间数量
export function fangNum(query) {
    return new Promise((resolve, reject) => {
        request({
            url: '/xiaoxiang.fang.fangnum',
            method: 'get',
            params: query
        }).then(response => {
            const res = response.data
            if (res.code == 0) {
                resolve(res)
            } else {
                reject(new Error(res.msg || '查询失败'))
            }
        }).catch(error => {
            reject(error)
        })
    })
}

//房型列表
export function fangjianList(params) {
    return new Promise((resolve, reject) => {
        params.communityId = getCommunityId()
        request({
            url: '/xiaoxiang.fang.fangjian.list',
            method: 'get',
            params
        }).then(response => {
            const res = response.data
            if (res.code == 0) {
                resolve(res)
            } else {
                reject(new Error(res.msg || '查询失败'))
            }
        }).catch(error => {
            reject(error)
        })
    })
}

//通知
export function listTongzhi(params) {
    return new Promise((resolve, reject) => {
        params.communityId = getCommunityId()
        request({
            url: '/xiaoxiang.fang.tongzhi.list',
            method: 'get',
            params
        }).then(response => {
            const res = response.data
            if (res.code == 0) {
                resolve(res)
            } else {
                reject(new Error(res.msg || '查询失败'))
            }
        }).catch(error => {
            reject(error)
        })
    })
}

export function getTongzhi(params) {
    return new Promise((resolve, reject) => {
        params.communityId = getCommunityId()
        request({
            url: '/xiaoxiang.fang.tongzhi.getInfo',
            method: 'get',
            params
        }).then(response => {
            const res = response.data
            if (res.code == 0) {
                resolve(res)
            } else {
                reject(new Error(res.msg || '查询失败'))
            }
        }).catch(error => {
            reject(error)
        })
    })
}

export function addTongzhi(params) {
    return new Promise((resolve, reject) => {
        params.communityId = getCommunityId()
        request({
            url: '/xiaoxiang.fang.tongzhi.add',
            method: 'get',
            params
        }).then(response => {
            const res = response.data
            if (res.code == 0) {
                resolve(res)
            } else {
                reject(new Error(res.msg || '查询失败'))
            }
        }).catch(error => {
            reject(error)
        })
    })
}
export function addMingxi(params) {
    return new Promise((resolve, reject) => {
        params.communityId = getCommunityId()
        request({
            url: '/xiaoxiang.fang.mingxi.add',
            method: 'get',
            params
        }).then(response => {
            const res = response.data
            if (res.code == 0) {
                resolve(res)
            } else {
                reject(new Error(res.msg || '查询失败'))
            }
        }).catch(error => {
            reject(error)
        })
    })
}

export function updateTongzhi(params) {
    return new Promise((resolve, reject) => {
        params.communityId = getCommunityId()
        request({
            url: '/xiaoxiang.fang.tongzhi.edit',
            method: 'get',
            params
        }).then(response => {
            const res = response.data
            if (res.code == 0) {
                resolve(res)
            } else {
                reject(new Error(res.msg || '查询失败'))
            }
        }).catch(error => {
            reject(error)
        })
    })
}
export function updateMingxi(params) {
    return new Promise((resolve, reject) => {
        params.communityId = getCommunityId()
        request({
            url: '/xiaoxiang.fang.mingxi.edit',
            method: 'get',
            params
        }).then(response => {
            const res = response.data
            if (res.code == 0) {
                resolve(res)
            } else {
                reject(new Error(res.msg || '查询失败'))
            }
        }).catch(error => {
            reject(error)
        })
    })
}
export function count(data) {
    return new Promise((resolve, reject) => {
        data.communityId = getCommunityId()
        request({
            url: '/xiaoxiang.fang.mingxi.count',
            method: 'post',
            data
        }).then(response => {
            const res = response.data
            if (res.code == 0) {
                resolve(res)
            } else {
                reject(new Error(res.msg || '查询失败'))
            }
        }).catch(error => {
            reject(error)
        })
    })
}

export function delTongzhi(params) {
    return new Promise((resolve, reject) => {
        params.communityId = getCommunityId()
        request({
            url: '/xiaoxiang.fang.tongzhi.remove',
            method: 'get',
            params
        }).then(response => {
            const res = response.data
            if (res.code == 0) {
                resolve(res)
            } else {
                reject(new Error(res.msg || '查询失败'))
            }
        }).catch(error => {
            reject(error)
        })
    })
}

//须知
export function listXuzhi(params) {
    return new Promise((resolve, reject) => {
        params.communityId = getCommunityId()
        request({
            url: '/xiaoxiang.fang.xuzhi.list',
            method: 'get',
            params
        }).then(response => {
            const res = response.data
            if (res.code == 0) {
                resolve(res)
            } else {
                reject(new Error(res.msg || '查询失败'))
            }
        }).catch(error => {
            reject(error)
        })
    })
}

export function getXuzhi(params) {
    return new Promise((resolve, reject) => {
        params.communityId = getCommunityId()
        request({
            url: '/xiaoxiang.fang.xuzhi.getInfo',
            method: 'get',
            params
        }).then(response => {
            const res = response.data
            if (res.code == 0) {
                resolve(res)
            } else {
                reject(new Error(res.msg || '查询失败'))
            }
        }).catch(error => {
            reject(error)
        })
    })
}

export function addXuzhi(params) {
    return new Promise((resolve, reject) => {
        params.communityId = getCommunityId()
        request({
            url: '/xiaoxiang.fang.xuzhi.add',
            method: 'get',
            params
        }).then(response => {
            const res = response.data
            if (res.code == 0) {
                resolve(res)
            } else {
                reject(new Error(res.msg || '查询失败'))
            }
        }).catch(error => {
            reject(error)
        })
    })
}

export function addZhekou(params) {
    return new Promise((resolve, reject) => {
        params.communityId = getCommunityId()
        request({
            url: '/xiaoxiang.fang.zhekou.add',
            method: 'get',
            params
        }).then(response => {
            const res = response.data
            if (res.code == 0) {
                resolve(res)
            } else {
                reject(new Error(res.msg || '查询失败'))
            }
        }).catch(error => {
            reject(error)
        })
    })
}

export function updateXuzhi(params) {
    return new Promise((resolve, reject) => {
        params.communityId = getCommunityId()
        request({
            url: '/xiaoxiang.fang.xuzhi.edit',
            method: 'get',
            params
        }).then(response => {
            const res = response.data
            if (res.code == 0) {
                resolve(res)
            } else {
                reject(new Error(res.msg || '查询失败'))
            }
        }).catch(error => {
            reject(error)
        })
    })
}
export function updateZhekou(params) {
    return new Promise((resolve, reject) => {
        params.communityId = getCommunityId()
        request({
            url: '/xiaoxiang.fang.zhekou.edit',
            method: 'get',
            params
        }).then(response => {
            const res = response.data
            if (res.code == 0) {
                resolve(res)
            } else {
                reject(new Error(res.msg || '查询失败'))
            }
        }).catch(error => {
            reject(error)
        })
    })
}

export function delXuzhi(params) {
    return new Promise((resolve, reject) => {
        params.communityId = getCommunityId()
        request({
            url: '/xiaoxiang.fang.xuzhi.remove',
            method: 'get',
            params
        }).then(response => {
            const res = response.data
            if (res.code == 0) {
                resolve(res)
            } else {
                reject(new Error(res.msg || '查询失败'))
            }
        }).catch(error => {
            reject(error)
        })
    })
}


//反馈
export function listFankui(params) {
    return new Promise((resolve, reject) => {
        params.communityId = getCommunityId()
        request({
            url: '/xiaoxiang.fang.fankui.list',
            method: 'get',
            params
        }).then(response => {
            const res = response.data
            if (res.code == 0) {
                resolve(res)
            } else {
                reject(new Error(res.msg || '查询失败'))
            }
        }).catch(error => {
            reject(error)
        })
    })
}
export function listLabe(params) {
    return new Promise((resolve, reject) => {
        params.communityId = getCommunityId()
        request({
            url: '/xiaoxiang.fang.labe.list',
            method: 'get',
            params
        }).then(response => {
            const res = response.data
            if (res.code == 0) {
                resolve(res)
            } else {
                reject(new Error(res.msg || '查询失败'))
            }
        }).catch(error => {
            reject(error)
        })
    })
}
export function getLabe(params) {
    return new Promise((resolve, reject) => {
        params.communityId = getCommunityId()
        request({
            url: '/xiaoxiang.fang.labe.getInfo',
            method: 'get',
            params
        }).then(response => {
            const res = response.data
            if (res.code == 0) {
                resolve(res)
            } else {
                reject(new Error(res.msg || '查询失败'))
            }
        }).catch(error => {
            reject(error)
        })
    })
}

export function listShuidian(params) {
    return new Promise((resolve, reject) => {
        params.communityId = getCommunityId()
        request({
            url: '/xiaoxiang.fang.shuidian.list',
            method: 'get',
            params
        }).then(response => {
            const res = response.data
            if (res.code == 0) {
                resolve(res)
            } else {
                reject(new Error(res.msg || '查询失败'))
            }
        }).catch(error => {
            reject(error)
        })
    })
}

export function listShuidianGuize(params) {
    return new Promise((resolve, reject) => {
        params.communityId = getCommunityId()
        request({
            url: '/xiaoxiang.fang.shuidianGuize.list',
            method: 'get',
            params
        }).then(response => {
            const res = response.data
            if (res.code == 0) {
                resolve(res)
            } else {
                reject(new Error(res.msg || '查询失败'))
            }
        }).catch(error => {
            reject(error)
        })
    })
}

export function listZhekou(params) {
    return new Promise((resolve, reject) => {
        params.communityId = getCommunityId()
        request({
            url: '/xiaoxiang.fang.zhekou.list',
            method: 'get',
            params
        }).then(response => {
            const res = response.data
            if (res.code == 0) {
                resolve(res)
            } else {
                reject(new Error(res.msg || '查询失败'))
            }
        }).catch(error => {
            reject(error)
        })
    })
}

export function getFankui(params) {
    return new Promise((resolve, reject) => {
        params.communityId = getCommunityId()
        request({
            url: '/xiaoxiang.fang.fankui.getInfo',
            method: 'get',
            params
        }).then(response => {
            const res = response.data
            if (res.code == 0) {
                resolve(res)
            } else {
                reject(new Error(res.msg || '查询失败'))
            }
        }).catch(error => {
            reject(error)
        })
    })
}
export function getZhekou(params) {
    return new Promise((resolve, reject) => {
        params.communityId = getCommunityId()
        request({
            url: '/xiaoxiang.fang.zhekou.getInfo',
            method: 'get',
            params
        }).then(response => {
            const res = response.data
            if (res.code == 0) {
                resolve(res)
            } else {
                reject(new Error(res.msg || '查询失败'))
            }
        }).catch(error => {
            reject(error)
        })
    })
}

export function getShuidian(params) {
    return new Promise((resolve, reject) => {
        params.communityId = getCommunityId()
        request({
            url: '/xiaoxiang.fang.shuidian.getInfo',
            method: 'get',
            params
        }).then(response => {
            const res = response.data
            if (res.code == 0) {
                resolve(res)
            } else {
                reject(new Error(res.msg || '查询失败'))
            }
        }).catch(error => {
            reject(error)
        })
    })
}

export function getShuidianGuize(params) {
    return new Promise((resolve, reject) => {
        params.communityId = getCommunityId()
        request({
            url: '/xiaoxiang.fang.shuidianGuize.getInfo',
            method: 'get',
            params
        }).then(response => {
            const res = response.data
            if (res.code == 0) {
                resolve(res)
            } else {
                reject(new Error(res.msg || '查询失败'))
            }
        }).catch(error => {
            reject(error)
        })
    })
}

export function daibanfangzu(params) {
    return new Promise((resolve, reject) => {
        params.communityId = getCommunityId()
        request({
            url: '/xiaoxiang.fang.fangInfo.daibanfangzu',
            method: 'get',
            params
        }).then(response => {
            const res = response.data
            if (res.code == 0) {
                resolve(res)
            } else {
                reject(new Error(res.msg || '查询失败'))
            }
        }).catch(error => {
            reject(error)
        })
    })
}

//添加房型
export function addFangxing(data) {
    return new Promise((resolve, reject) => {
        const communityId = getCommunityId()
        request({
            url: '/xiaoxiang.fang.fangxing.add',
            method: 'post',
            data: {
                ...data,
                communityId
            }
        }).then(response => {
            const res = response.data
            if (res.code === 0) {
                resolve(res)
            } else {
                reject(new Error(res.msg || '添加失败'))
            }
        }).catch(error => {
            reject(error)
        })
    })
}

//添加房间
export function addFangJian(data) {
    return new Promise((resolve, reject) => {
        const communityId = getCommunityId()
        request({
            url: '/xiaoxiang.fang.fangjian.add',
            method: 'post',
            data: {
                ...data,
                communityId
            }
        }).then(response => {
            const res = response.data
            if (res.code === 0) {
                resolve(res)
            } else {
                reject(new Error(res.msg || '添加失败'))
            }
        }).catch(error => {
            reject(error)
        })
    })
}

//修改房型
export function editFangxing(data) {
    return new Promise((resolve, reject) => {
        const communityId = getCommunityId()
        request({
            url: '/xiaoxiang.fang.fangxing.edit',
            method: 'post',
            data: {
                ...data,
                communityId
            }
        }).then(response => {
            const res = response.data
            if (res.code === 0) {
                resolve(res)
            } else {
                reject(new Error(res.msg || '编辑失败'))
            }
        }).catch(error => {
            reject(error)
        })
    })
}

export function updateShuidian(data) {
    return new Promise((resolve, reject) => {
        const communityId = getCommunityId()
        request({
            url: '/xiaoxiang.fang.shuidian.edit',
            method: 'post',
            data: {
                ...data,
                communityId
            }
        }).then(response => {
            const res = response.data
            if (res.code === 0) {
                resolve(res)
            } else {
                // reject(new Error(res.msg || '编辑失败'))
                console.log(res.msg)
            }
        }).catch(error => {
            reject(error)
        })
    })
}

export function dianqian(data) {
    return new Promise((resolve, reject) => {
        request({
            url: '/xiaoxiang.fang.shuidian.dianqian',
            method: 'post',
            data
        }).then(response => {
            const res = response.data
            console.log('res: ' + res)
            if (res.code === 0) {
                resolve(res)
            } else {
                reject(new Error(res.msg || '编辑失败'))
            }
        }).catch(error => {
            reject(error)
        })
    })
}

export function shuiqian(data) {
    return new Promise((resolve, reject) => {
        request({
            url: '/xiaoxiang.fang.shuidian.shuiqian',
            method: 'post',
            data
        }).then(response => {
            const res = response.data
            if (res.code === 0) {
                resolve(res)
            } else {
                reject(new Error(res.msg || '编辑失败'))
            }
        }).catch(error => {
            reject(error)
        })
    })
}

export function listMingxi(data) {
    return new Promise((resolve, reject) => {
        request({
            url: '/xiaoxiang.fang.mingxi.list',
            method: 'post',
            data
        }).then(response => {
            const res = response.data
            if (res.code === 0) {
                resolve(res)
            } else {
                reject(new Error(res.msg || '编辑失败'))
            }
        }).catch(error => {
            reject(error)
        })
    })
}

export function listOrderInfo(data) {
    return new Promise((resolve, reject) => {
        request({
            url: '/xiaoxiang.fang.orderInfo.list',
            method: 'post',
            data
        }).then(response => {
            const res = response.data
            if (res.code === 0) {
                resolve(res)
            } else {
                reject(new Error(res.msg || '编辑失败'))
            }
        }).catch(error => {
            reject(error)
        })
    })
}

export function addLabe(data) {
    return new Promise((resolve, reject) => {
        request({
            url: '/xiaoxiang.fang.labe.add',
            method: 'post',
            data
        }).then(response => {
            const res = response.data
            if (res.code === 0) {
                resolve(res)
            } else {
                reject(new Error(res.msg || '编辑失败'))
            }
        }).catch(error => {
            reject(error)
        })
    })
}
export function updateLabe(data) {
    return new Promise((resolve, reject) => {
        request({
            url: '/xiaoxiang.fang.labe.edit',
            method: 'post',
            data
        }).then(response => {
            const res = response.data
            if (res.code === 0) {
                resolve(res)
            } else {
                reject(new Error(res.msg || '编辑失败'))
            }
        }).catch(error => {
            reject(error)
        })
    })
}
export function listLunbo(data) {
    return new Promise((resolve, reject) => {
        request({
            url: '/xiaoxiang.fang.lunbo.list',
            method: 'post',
            data
        }).then(response => {
            const res = response.data
            if (res.code === 0) {
                resolve(res)
            } else {
                reject(new Error(res.msg || '编辑失败'))
            }
        }).catch(error => {
            reject(error)
        })
    })
}
export function getLunbo(data) {
    return new Promise((resolve, reject) => {
        request({
            url: '/xiaoxiang.fang.lunbo.getInfo',
            method: 'post',
            data
        }).then(response => {
            const res = response.data
            if (res.code === 0) {
                resolve(res)
            } else {
                reject(new Error(res.msg || '编辑失败'))
            }
        }).catch(error => {
            reject(error)
        })
    })
}
export function addLunbo(data) {
    return new Promise((resolve, reject) => {
        request({
            url: '/xiaoxiang.fang.lunbo.add',
            method: 'get',
            data
        }).then(response => {
            const res = response.data
            if (res.code === 0) {
                resolve(res)
            } else {
                reject(new Error(res.msg || '编辑失败'))
            }
        }).catch(error => {
            reject(error)
        })
    })
}
export function updateLunbo(data) {
    return new Promise((resolve, reject) => {
        request({
            url: '/xiaoxiang.fang.lunbo.edit',
            method: 'get',
            data
        }).then(response => {
            const res = response.data
            if (res.code === 0) {
                resolve(res)
            } else {
                reject(new Error(res.msg || '编辑失败'))
            }
        }).catch(error => {
            reject(error)
        })
    })
}
export function delLunbo(data) {
    return new Promise((resolve, reject) => {
        request({
            url: '/xiaoxiang.fang.lunbo.remove',
            method: 'get',
            data
        }).then(response => {
            const res = response.data
            if (res.code === 0) {
                resolve(res)
            } else {
                reject(new Error(res.msg || '编辑失败'))
            }
        }).catch(error => {
            reject(error)
        })
    })
}
export function delLabe(data) {
    return new Promise((resolve, reject) => {
        request({
            url: '/xiaoxiang.fang.labe.remove',
            method: 'post',
            data
        }).then(response => {
            const res = response.data
            if (res.code === 0) {
                resolve(res)
            } else {
                reject(new Error(res.msg || '编辑失败'))
            }
        }).catch(error => {
            reject(error)
        })
    })
}

export function listShuidianInfo(data) {
    return new Promise((resolve, reject) => {
        request({
            url: '/xiaoxiang.fang.shuidianInfo.list',
            method: 'post',
            data
        }).then(response => {
            const res = response.data
            if (res.code === 0) {
                resolve(res)
            } else {
                reject(new Error(res.msg || '编辑失败'))
            }
        }).catch(error => {
            reject(error)
        })
    })
}

//修改房间
export function updateFangJian(data) {
    return new Promise((resolve, reject) => {
        const communityId = getCommunityId()
        request({
            url: '/xiaoxiang.fang.fangjian.edit',
            method: 'post',
            data: {
                ...data,
                communityId
            }
        }).then(response => {
            const res = response.data
            if (res.code === 0) {
                resolve(res)
            } else {
                reject(new Error(res.msg || '编辑失败'))
            }
        }).catch(error => {
            reject(error)
        })
    })
}

export function updateShuidianGuize(data) {
    return new Promise((resolve, reject) => {
        data.communityId = getCommunityId()
        request({
            url: '/xiaoxiang.fang.shuidianGuize.edit',
            method: 'post',
            data
        }).then(response => {
            const res = response.data
            if (res.code === 0) {
                resolve(res)
            } else {
                reject(new Error(res.msg || '编辑失败'))
            }
        }).catch(error => {
            reject(error)
        })
    })
}

// 房间数量
export function fangjianById(params) {
    return new Promise((resolve, reject) => {
        params.communityId = getCommunityId()
        request({
            url: '/xiaoxiang.fang.fangjianbyid',
            method: 'get',
            params
        }).then(response => {
            const res = response.data
            if (res.code == 0) {
                resolve(res)
            } else {
                reject(new Error(res.msg || '查询失败'))
            }
        }).catch(error => {
            reject(error)
        })
    })
}
export function mingxiExort(data) {
    return new Promise((resolve, reject) => {
        data.communityId = getCommunityId()
        request({
            url: '/xiaoxiang.fang.mingxi.export',
            method: 'post',
            data
        }).then(response => {
            const res = response.data
            if (res.code == 0) {
                resolve(res)
            } else {
                reject(new Error(res.msg || '查询失败'))
            }
        }).catch(error => {
            reject(error)
        })
    })
}
export function getFangJianByXingId(params) {
    return new Promise((resolve, reject) => {
        params.communityId = getCommunityId()
        request({
            url: '/xiaoxiang.fang.fangjian.getFangjianByXingid',
            method: 'get',
            params
        }).then(response => {
            const res = response.data
            if (res.code == 0) {
                resolve(res)
            } else {
                reject(new Error(res.msg || '查询失败'))
            }
        }).catch(error => {
            reject(error)
        })
    })
}
export function listFangInfo(params) {
    return new Promise((resolve, reject) => {
        params.communityId = getCommunityId()
        request({
            url: '/xiaoxiang.fang.fangInfo.list',
            method: 'get',
            params
        }).then(response => {
            const res = response.data
            if (res.code == 0) {
                resolve(res)
            } else {
                reject(new Error(res.msg || '查询失败'))
            }
        }).catch(error => {
            reject(error)
        })
    })
}
export function jiesuan(params) {
    return new Promise((resolve, reject) => {
        params.communityId = getCommunityId()
        request({
            url: '/xiaoxiang.fang.fangInfo.jiesuan',
            method: 'get',
            params
        }).then(response => {
            const res = response.data
            if (res.code == 0) {
                resolve(res)
            } else {
                reject(new Error(res.msg || '查询失败'))
            }
        }).catch(error => {
            reject(error)
        })
    })
}
export function refund(params) {
    return new Promise((resolve, reject) => {
        params.communityId = getCommunityId()
        request({
            url: '/xiaoxiang.fang.fangInfo.refund',
            method: 'get',
            params
        }).then(response => {
            const res = response.data
            if (res.code == 0) {
                resolve(res)
            } else {
                reject(new Error(res.msg || '查询失败'))
            }
        }).catch(error => {
            reject(error)
        })
    })
}
export function getFangInfo(params) {
    return new Promise((resolve, reject) => {
        params.communityId = getCommunityId()
        request({
            url: '/xiaoxiang.fang.fangInfo.getInfo',
            method: 'get',
            params
        }).then(response => {
            const res = response.data
            if (res.code == 0) {
                resolve(res)
            } else {
                reject(new Error(res.msg || '查询失败'))
            }
        }).catch(error => {
            reject(error)
        })
    })
}
export function addFangInfo(params) {
    return new Promise((resolve, reject) => {
        request({
            url: '/xiaoxiang.fang.fangInfo.add',
            method: 'get',
            params
        }).then(response => {
            const res = response.data
            if (res.code == 0) {
                resolve(res)
            } else {
                reject(new Error(res.msg || '查询失败'))
            }
        }).catch(error => {
            reject(error)
        })
    })
}
export function updateFangInfo(params) {
    return new Promise((resolve, reject) => {
        params.communityId = getCommunityId()
        request({
            url: '/xiaoxiang.fang.fangInfo.edit',
            method: 'post',
            params
        }).then(response => {
            const res = response.data
            if (res.code == 0) {
                resolve(res)
            } else {
                reject(new Error(res.msg || '查询失败'))
            }
        }).catch(error => {
            reject(error)
        })
    })
}
export function delFangInfo(params) {
    return new Promise((resolve, reject) => {
        params.communityId = getCommunityId()
        request({
            url: '/xiaoxiang.fang.fangInfo.remove',
            method: 'post',
            params
        }).then(response => {
            const res = response.data
            if (res.code == 0) {
                resolve(res)
            } else {
                reject(new Error(res.msg || '查询失败'))
            }
        }).catch(error => {
            reject(error)
        })
    })
}

//查询单个房型信息
export function getFangxingInfo(params) {
    return new Promise((resolve, reject) => {
        params.communityId = getCommunityId()
        request({
            url: '/xiaoxiang.fang.fangxing.getInfo',
            method: 'get',
            params
        }).then(response => {
            const res = response.data
            if (res.code == 0) {
                resolve(res)
            } else {
                reject(new Error(res.msg || '查询失败'))
            }
        }).catch(error => {
            reject(error)
        })
    })
}
export function getMingxi(params) {
    return new Promise((resolve, reject) => {
        params.communityId = getCommunityId()
        request({
            url: '/xiaoxiang.fang.mingxi.getInfo',
            method: 'get',
            params
        }).then(response => {
            const res = response.data
            if (res.code == 0) {
                resolve(res)
            } else {
                reject(new Error(res.msg || '查询失败'))
            }
        }).catch(error => {
            reject(error)
        })
    })
}

//删除房型
export function delFangxing(data) {
    return new Promise((resolve, reject) => {
        const communityId = getCommunityId()
        request({
            url: '/xiaoxiang.fang.fangxing.remove',
            method: 'post',
            data: {
                ...data,
                communityId
            }
        }).then(response => {
            const res = response.data
            if (res.code === 0) {
                resolve(res)
            } else {
                reject(new Error(res.msg || '删除失败'))
            }
        }).catch(error => {
            reject(error)
        })
    })
}
export function delZhekou(data) {
    return new Promise((resolve, reject) => {
        const communityId = getCommunityId()
        request({
            url: '/xiaoxiang.fang.zhekou.remove',
            method: 'get',
            data: {
                ...data,
                communityId
            }
        }).then(response => {
            const res = response.data
            if (res.code === 0) {
                resolve(res)
            } else {
                reject(new Error(res.msg || '删除失败'))
            }
        }).catch(error => {
            reject(error)
        })
    })
}
export function delMingxi(data) {
    return new Promise((resolve, reject) => {
        const communityId = getCommunityId()
        request({
            url: '/xiaoxiang.fang.mingxi.remove',
            method: 'post',
            data: {
                ...data,
                communityId
            }
        }).then(response => {
            const res = response.data
            if (res.code === 0) {
                resolve(res)
            } else {
                reject(new Error(res.msg || '删除失败'))
            }
        }).catch(error => {
            reject(error)
        })
    })
}

//删除房型
export function delFangJian(data) {
    console.log('222');
    return new Promise((resolve, reject) => {
        const communityId = getCommunityId()

        request({
            url: '/xiaoxiang.fang.fangjian.remove',
            method: 'post',
            data: {
                ...data,
                communityId
            }
        }).then(response => {
            const res = response.data
            if (res.code === 0) {
                resolve(res)
            } else {
                reject(new Error(res.msg || '删除失败'))
            }
        }).catch(error => {
            reject(error)
        })
    })
}

// xiaoxiang.fang.fangxing.edit
// xiaoxiang.fang.fangxing.getInfo?id=
//     xiaoxiang.fang.fangxing.remove?ids=  多个用英文逗号拼接
